var _rect, _circle, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGranulesIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    fill: "#f8f9fa"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 105,
    r: 75,
    fill: "#27ae60"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 118,
    fontFamily: "Arial Black, Arial, sans-serif",
    fontSize: 52,
    fontWeight: 900,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "#ffffff",
    letterSpacing: 1
  }, "GI")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 210,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    textAnchor: "middle",
    fill: "#2c3e50"
  }, "Granules India")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 228,
    fontFamily: "Arial, sans-serif",
    fontSize: 9,
    textAnchor: "middle",
    fill: "#7f8c8d"
  }, "Granules India")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGranulesIndia);
export default __webpack_public_path__ + "static/media/Granules_India.932b90ab4f9a6c33ea3826082514926c.svg";
export { ForwardRef as ReactComponent };